import { format } from 'date-fns';
import moment from 'moment-timezone';
import { useCallback, useEffect, useId, useMemo } from 'react';

import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import CustomDateInput from 'src/sections/invoice_details/invoiceInfo/CustomDateInput';
import { getBgColor, getIcon } from 'src/utils/icons';
import { convertDate } from 'src/utils/transformation';

const DocumentDate = () => {
  const { updateFormData, errors, receiptData, isInProgress } = useReceiptDetails();
  const formatDate = useMemo(
    () =>
      receiptData?.documentDate !== null
        ? format(convertDate(receiptData?.documentDate), 'LLL dd, yyyy').toString()
        : undefined,
    [receiptData?.documentDate]
  );
  const hasError = useMemo(() => !!errors.documentDate.length, [errors.documentDate.length]);
  const preventDefault = useCallback((e: any) => {
    e.preventDefault();
  }, []);

  const id = useId();

  useEffect(() => {
    document.getElementById(id)?.addEventListener('keyup', (e: any) => {
      updateFormData('_documentDate', e.target.value);
    });
    return document.getElementById(id)?.removeEventListener('keyup', (e) => {});
  }, [id, updateFormData]);

  const handleInputChange = useCallback(
    (date: Date | null) => {
      updateFormData('documentDate', date);
      if (date) {
        updateFormData('_documentDate', moment(date).format('MM/DD/YYYY'));
      }
    },
    [updateFormData]
  );

  return (
    <PopUp
      show={hasError}
      content={
        <div className="m-1 max-w-[300px]">
          <PopUpContentWrapper contents={errors.documentDate} type="Error" />
        </div>
      }
    >
      <div className={`p-1 ${getBgColor(errors.documentDate)} text-[13px]`}>
        <p className="font-bold pb-1 flex items-center whitespace-nowrap">
          Document Date <span className="inline-block px-2">{getIcon(errors.documentDate)}</span>
        </p>
        {isInProgress ? (
          <span onDragStart={preventDefault} onDragOver={preventDefault}>
            <CustomDateInput
              value={receiptData?.documentDate ? convertDate(receiptData?.documentDate) : undefined}
              valid={!hasError}
              id={id}
              onChange={handleInputChange}
            />
          </span>
        ) : (
          <p>{formatDate}</p>
        )}
      </div>
    </PopUp>
  );
};

export default DocumentDate;
